import cookie from 'js-cookie';

const removeTKCookie = name =>
  cookie.remove(name, {path: '/', domain: '.theknot.com'});

export default removeTKCookie;
